export const MaleIcon = ({ className = "w-6 h-6 md:w-7 md:h-7" }: { className?: string }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path
				stroke="none"
				d="M0 0h24v24H0z"
				fill="none"
			/>
			<path d="M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
			<path d="M19 5l-5.4 5.4" />
			<path d="M19 5h-5" />
			<path d="M19 5v5" />
		</svg>
	);
};
